export function Logo({ className = "" }: { className?: string }) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 48 48"
      fill="none"
      className={className}
    >
      <path
        d="M8 8C8 6.89543 8.89543 6 10 6H22V42H10C8.89543 42 8 41.1046 8 40V8Z"
        fill="#E8E4F0"
        stroke="#4A5568"
        strokeWidth="2"
      />
      <path
        d="M22 6H38C39.1046 6 40 6.89543 40 8V40C40 41.1046 39.1046 42 38 42H22V6Z"
        fill="#FFFFFF"
        stroke="#4A5568"
        strokeWidth="2"
      />
      <path
        d="M15 12V36"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="15" cy="14" r="2.5" fill="#4A5568" />
      <circle cx="15" cy="22" r="2.5" fill="#4A5568" />
      <circle cx="15" cy="30" r="2.5" fill="#4A5568" />
      <path
        d="M15 22C15 22 18 22 20 24C22 26 26 28 26 28"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="26" cy="28" r="2" fill="#6B5B95" />
      <line
        x1="26"
        y1="14"
        x2="36"
        y2="14"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26"
        y1="20"
        x2="34"
        y2="20"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26"
        y1="34"
        x2="36"
        y2="34"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26"
        y1="38"
        x2="32"
        y2="38"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LogoSmall({ className = "" }: { className?: string }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 48 48"
      fill="none"
      className={className}
    >
      <path
        d="M8 8C8 6.89543 8.89543 6 10 6H22V42H10C8.89543 42 8 41.1046 8 40V8Z"
        fill="#E8E4F0"
        stroke="#4A5568"
        strokeWidth="2"
      />
      <path
        d="M22 6H38C39.1046 6 40 6.89543 40 8V40C40 41.1046 39.1046 42 38 42H22V6Z"
        fill="#FFFFFF"
        stroke="#4A5568"
        strokeWidth="2"
      />
      <path
        d="M15 12V36"
        stroke="#4A5568"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="15" cy="18" r="2" fill="#4A5568" />
      <circle cx="15" cy="30" r="2" fill="#4A5568" />
    </svg>
  );
}
